/**
 * Country for Storefront `@inContext` (drives market-translated metafields
 * like `custom.custom_deep_link`). Prefer the URL locale segment (`/en-gb/` →
 * GB) over `Shopify.country`, which can lag when browsing EMEA markets —
 * same approach as `isUsMarket()` in product-card-custom.js.
 * @returns {string}
 */
function getStorefrontCountryCode() {
  const pathSegment =
    String(window.location?.pathname || '')
      .split('/')
      .find(Boolean) || '';

  if (/^[a-z]{2}-[a-z]{2}$/i.test(pathSegment)) {
    return pathSegment.split('-')[1].toUpperCase();
  }

  return String(Shopify.country || 'US').toUpperCase();
}

const STOREFRONT_CONTEXT_DIRECTIVE = `@inContext(country: ${getStorefrontCountryCode()}, language: ${Shopify.locale
  .toUpperCase()
  .replace('-', '_')})`;

export const PRODUCT_TILE_NODES_QUERY = `
  query fetchProductTiles($ids: [ID!]!) ${STOREFRONT_CONTEXT_DIRECTIVE} {
    nodes(ids: $ids) {
      ... on Product {
        id
        handle
        title
        availableForSale
        tags
        collections(first: 100) {
          nodes {
            id
          }
        }
        options(first: 250) {
          name
          optionValues {
            name
          }
        }
        variants(first: 250) {
          nodes {
            availableForSale
            compareAtPrice {
              amount
              currencyCode
            }
            id
            image {
              url(transform: { maxWidth: 500 })
              width
              height
              altText
            }
            price {
              amount
              currencyCode
            }
            quantityAvailable
            selectedOptions {
              name
              value
            }
            metafields(
              identifiers: [
                { namespace: "custom", key: "new_color" }
                { namespace: "custom", key: "variant_is_new" }
                { namespace: "custom", key: "article_code" }
                { namespace: "custom", key: "product_line_collection_key" }
              ]
            ) {
              value
              key
            }
          }
        }
        images(first: 250) {
          nodes {
            url(transform: { maxWidth: 350 })
            width
            height
            altText
          }
        }
        metafields(
          identifiers: [
            { namespace: "custom", key: "secondary_badge_copy" }
            { namespace: "custom", key: "custom_deep_link" }
            { namespace: "custom", key: "doogma_template_id" }
            { namespace: "custom", key: "product_classification" }
            { namespace: "custom", key: "launch_date" }
            { namespace: "custom", key: "is_best_seller" }
            { namespace: "custom", key: "promo_message" }
            { namespace: "custom", key: "out_of_stock_state" }
            { namespace: "custom", key: "capture_at_order" }
            { namespace: "custom", key: "tennis_stringing_options" }
            { namespace: "custom", key: "custom_bats" }
          ]
        ) {
          value
          key
        }
        earlyAccessCampaign: metafield(namespace: "custom", key: "early_access_campaign") {
          reference {
            ... on Metaobject {
              urlParam: field(key: "url_param") { value }
              us: field(key: "us_early_access_until") { value }
              de: field(key: "de_early_access_until") { value }
              fr: field(key: "fr_early_access_until") { value }
              es: field(key: "es_early_access_until") { value }
              it: field(key: "it_early_access_until") { value }
              gb: field(key: "gb_early_access_until") { value }
            }
          }
        }
      }
    }
  }`;
